import React, { Component } from 'react';
import { Alert, Button, Col, Form, Modal } from 'react-bootstrap';
import WorkflowSequence from './WorkflowSequence';
import './WorkflowAdd.css';

class WorkflowAdd extends Component {
    state = { name: '', description: '', sequence: '', errMsg: '', saving: false };

    componentDidUpdate(previous) {
        if (this.props.showAddWorkflow && !previous.showAddWorkflow) {
            this.setState({ name: '', description: '', sequence: '', errMsg: '' });
        }
    }

    handleSubmitAddWorkflow = async event => {
        event.preventDefault();
        if (this.state.saving) return;
        this.setState({ saving: true, errMsg: '' });
        try {
            const { name, description, sequence } = this.state;
            const response = await fetch('workflow_add', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                body: new URLSearchParams({ name, description, sequence }).toString()
            });
            if (!response.ok) throw new Error('Could not add the workflow. Please try again.');
            const data = await response.json();
            if (data[0].Success !== 'true') throw new Error(data[0].Msg || 'Could not add the workflow.');
            this.props.reloadWorkflows();
            this.props.hideAddWorkflow();
        } catch (error) {
            this.setState({ errMsg: error.message });
        } finally {
            this.setState({ saving: false });
        }
    }

    render() {
        const { saving } = this.state;
        return <Modal show={this.props.showAddWorkflow} onHide={saving ? () => {} : this.props.hideAddWorkflow}
            backdrop="static" centered size="lg" dialogClassName="workflow-dialog" aria-labelledby="add-workflow-title">
            <Modal.Header closeButton={!saving}><Modal.Title id="add-workflow-title">Add Workflow</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form id="workflow-add-form" onSubmit={this.handleSubmitAddWorkflow}>
                    <fieldset disabled={saving}>
                        <Form.Row>
                            <Form.Group as={Col} controlId="workflow-add-name">
                                <Form.Label>Name</Form.Label>
                                <Form.Control value={this.state.name} onChange={event => this.setState({ name: event.target.value, errMsg: '' })} />
                            </Form.Group>
                            <Form.Group as={Col} controlId="workflow-add-description">
                                <Form.Label>Description</Form.Label>
                                <Form.Control value={this.state.description} onChange={event => this.setState({ description: event.target.value, errMsg: '' })} />
                            </Form.Group>
                        </Form.Row>
                        <WorkflowSequence inputId="workflow-add-process" value={this.state.sequence}
                            onChange={sequence => this.setState({ sequence, errMsg: '' })} {...this.props.sequenceProps} />
                    </fieldset>
                </Form>
                {this.state.errMsg && <Alert variant="danger" role="alert">{this.state.errMsg}</Alert>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" disabled={saving} onClick={this.props.hideAddWorkflow}>Cancel</Button>
                <Button type="submit" form="workflow-add-form" disabled={saving}>{saving ? 'Saving…' : 'Add Workflow'}</Button>
            </Modal.Footer>
        </Modal>;
    }
}

export default WorkflowAdd;
